// extracted by mini-css-extract-plugin
module.exports = {"animate-height":"PageAuth_animate-height__2d6jn","Alert":"PageAuth_Alert__1e-0a","animateHeight":"PageAuth_animateHeight__ZZ7ZZ"};